import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { GridType } from '@/contexts/LobbyUiContext';
import {
    CombineGameType,
    GameType as CommonGameType,
} from '@/models/games/enums/GameType';
import { useContext, useState } from 'react';
import { useLocalStorage } from './storage/useLocalStorage';
export type FilterType = CombineGameType | CommonGameType | -1;
export const useLobbyUI = () => {
    const [grid, setGrid] = useLocalStorage<GridType>('gridType', 0);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const [gameFilter, setGameFilter] = useState<FilterType>(-1);
    const [isShowGridToggle, setIsShowGridToggle] = useState(false);
    const [isShowGameFilter, setIsShowGameFilter] = useState(false);

    const toggleGrid = () => {
        playButtonAudio();
        const type = ((grid + 1) % 3) as GridType;
        setGrid(type);
    };
    return {
        grid,
        toggleGrid,
        gameFilter,
        setGameFilter,
        isShowGridToggle,
        setIsShowGridToggle,
        isShowGameFilter,
        setIsShowGameFilter,
    };
};
export type useLobbyUIState = ReturnType<typeof useLobbyUI>;
